var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAFlagUk24 = function SvgAFlagUk24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V17.9976H24V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8002 10.7928V17.9976H13.2006V10.7928H24V7.1952H13.2006V0H10.8002V7.1952H0V10.7928H10.8002Z",
    fill: "#CF142B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9927 5.826V0H21.7591L13.9927 5.826Z",
    fill: "#00247D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9927 12.1716V17.9976H21.7591L13.9927 12.1716Z",
    fill: "#00247D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99443 12.1716V17.9976H2.22803L9.99443 12.1716Z",
    fill: "#00247D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99443 5.826V0H2.22803L9.99443 5.826Z",
    fill: "#00247D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.67278V5.99878H5.7672L0 1.67278Z",
    fill: "#00247D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9876 1.67278V5.99878H18.2212L23.9876 1.67278Z",
    fill: "#00247D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9876 16.3248V11.9988H18.2212L23.9876 16.3248Z",
    fill: "#00247D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.3248V11.9988H5.7672L0 16.3248Z",
    fill: "#00247D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9871 0H22.6551L14.6719 5.9988H16.0039L23.9999 0",
    fill: "#CF142B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3152 11.9988H7.9832L0 17.9976H1.332L9.328 11.9988",
    fill: "#CF142B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6616 6.0036H7.9936L0 0V1.0056L6.6616 6.0036Z",
    fill: "#CF142B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3217 11.9964H15.9897L23.9833 18V16.9944L17.3217 11.9964Z",
    fill: "#CF142B"
  })));
};
export { SvgAFlagUk24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyNCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0IDBIMFYxNy45OTc2SDI0VjBaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTAuODAwMiAxMC43OTI4VjE3Ljk5NzZIMTMuMjAwNlYxMC43OTI4SDI0VjcuMTk1MkgxMy4yMDA2VjBIMTAuODAwMlY3LjE5NTJIMFYxMC43OTI4SDEwLjgwMDJaIiBmaWxsPSIjQ0YxNDJCIi8+CjxwYXRoIGQ9Ik0xMy45OTI3IDUuODI2VjBIMjEuNzU5MUwxMy45OTI3IDUuODI2WiIgZmlsbD0iIzAwMjQ3RCIvPgo8cGF0aCBkPSJNMTMuOTkyNyAxMi4xNzE2VjE3Ljk5NzZIMjEuNzU5MUwxMy45OTI3IDEyLjE3MTZaIiBmaWxsPSIjMDAyNDdEIi8+CjxwYXRoIGQ9Ik05Ljk5NDQzIDEyLjE3MTZWMTcuOTk3NkgyLjIyODAzTDkuOTk0NDMgMTIuMTcxNloiIGZpbGw9IiMwMDI0N0QiLz4KPHBhdGggZD0iTTkuOTk0NDMgNS44MjZWMEgyLjIyODAzTDkuOTk0NDMgNS44MjZaIiBmaWxsPSIjMDAyNDdEIi8+CjxwYXRoIGQ9Ik0wIDEuNjcyNzhWNS45OTg3OEg1Ljc2NzJMMCAxLjY3Mjc4WiIgZmlsbD0iIzAwMjQ3RCIvPgo8cGF0aCBkPSJNMjMuOTg3NiAxLjY3Mjc4VjUuOTk4NzhIMTguMjIxMkwyMy45ODc2IDEuNjcyNzhaIiBmaWxsPSIjMDAyNDdEIi8+CjxwYXRoIGQ9Ik0yMy45ODc2IDE2LjMyNDhWMTEuOTk4OEgxOC4yMjEyTDIzLjk4NzYgMTYuMzI0OFoiIGZpbGw9IiMwMDI0N0QiLz4KPHBhdGggZD0iTTAgMTYuMzI0OFYxMS45OTg4SDUuNzY3MkwwIDE2LjMyNDhaIiBmaWxsPSIjMDAyNDdEIi8+CjxwYXRoIGQ9Ik0yMy45ODcxIDBIMjIuNjU1MUwxNC42NzE5IDUuOTk4OEgxNi4wMDM5TDIzLjk5OTkgMCIgZmlsbD0iI0NGMTQyQiIvPgo8cGF0aCBkPSJNOS4zMTUyIDExLjk5ODhINy45ODMyTDAgMTcuOTk3NkgxLjMzMkw5LjMyOCAxMS45OTg4IiBmaWxsPSIjQ0YxNDJCIi8+CjxwYXRoIGQ9Ik02LjY2MTYgNi4wMDM2SDcuOTkzNkwwIDBWMS4wMDU2TDYuNjYxNiA2LjAwMzZaIiBmaWxsPSIjQ0YxNDJCIi8+CjxwYXRoIGQ9Ik0xNy4zMjE3IDExLjk5NjRIMTUuOTg5N0wyMy45ODMzIDE4VjE2Ljk5NDRMMTcuMzIxNyAxMS45OTY0WiIgZmlsbD0iI0NGMTQyQiIvPgo8L3N2Zz4K";